import { useTranslation } from 'react-i18next';

/**
 * Ввод [+]: по концепции открывается сразу камерой (еда — самый частый
 * ввод), рядом чипы других способов. Этап 0: каркас без камеры;
 * мост Capacitor Camera — этап 1.
 */
export function AddScreen(): JSX.Element {
  const { t } = useTranslation();
  const chips = ['workout', 'weight', 'habit', 'barcode', 'text'] as const;
  return (
    <main className="screen">
      <h1 className="type-h1 screen-title">{t('add.title')}</h1>
      <section
        className="card"
        style={{ minHeight: 280, display: 'flex', alignItems: 'center', justifyContent: 'center' }}
      >
        <p className="type-body-15 muted" style={{ margin: 0, textAlign: 'center' }}>
          {t('add.hint')}
        </p>
      </section>
      <div className="chips">
        {chips.map((c) => (
          <span key={c} className="chip">
            <span className="type-caption-13">{t(`add.chips.${c}`)}</span>
          </span>
        ))}
      </div>
    </main>
  );
}
